import { createAction } from "@reduxjs/toolkit";
const ACTION_PREFIX = "@auvious-redux::";
export const action = (name) => ACTION_PREFIX + name;
const REGISTER_REQUEST = action("REGISTER_REQUEST");
const REGISTER_SUCCESS = action("REGISTER_SUCCESS");
const REGISTER_FAILURE = action("REGISTER_FAILURE");
export const registerRequest = createAction(REGISTER_REQUEST);
export const registerSuccess = createAction(REGISTER_SUCCESS);
export const registerFailure = createAction(REGISTER_FAILURE);
const UNREGISTER_REQUEST = action("UNREGISTER_REQUEST");
const UNREGISTER_SUCCESS = action("UNREGISTER_SUCCESS");
const UNREGISTER_FAILURE = action("UNREGISTER_FAILURE");
export const unregisterRequest = createAction(UNREGISTER_REQUEST);
export const unregisterSuccess = createAction(UNREGISTER_SUCCESS);
export const unregisterFailure = createAction(UNREGISTER_FAILURE);
export const CREATE_ENDPOINT_REQUEST = action("CREATE_ENDPOINT_REQUEST");
export const CREATE_ENDPOINT_SUCCESS = action("CREATE_ENDPOINT_SUCCESS");
export const CREATE_ENDPOINT_FAILURE = action("CREATE_ENDPOINT_FAILURE");
export const createEndpointRequest = createAction(CREATE_ENDPOINT_REQUEST);
export const createEndpointSuccess = createAction(CREATE_ENDPOINT_SUCCESS);
export const createEndpointFailure = createAction(CREATE_ENDPOINT_FAILURE);
export const DESTROY_ENDPOINT_REQUEST = action("DESTROY_ENDPOINT_REQUEST");
export const DESTROY_ENDPOINT_SUCCESS = action("DESTROY_ENDPOINT_SUCCESS");
export const DESTROY_ENDPOINT_FAILURE = action("DESTROY_ENDPOINT_FAILURE");
export const destroyEndpointRequest = createAction(DESTROY_ENDPOINT_REQUEST);
export const destroyEndpointSuccess = createAction(DESTROY_ENDPOINT_SUCCESS);
export const destroyEndpointFailure = createAction(DESTROY_ENDPOINT_FAILURE);
export const CONNECT_TO_MQTT_REQUEST = action("CONNECT_TO_MQTT_REQUEST");
export const CONNECT_TO_MQTT_SUCCESS = action("CONNECT_TO_MQTT_SUCCESS");
export const CONNECT_TO_MQTT_FAILURE = action("CONNECT_TO_MQTT_FAILURE");
export const connectToMqttRequest = createAction(CONNECT_TO_MQTT_REQUEST);
export const connectToMqttSuccess = createAction(CONNECT_TO_MQTT_SUCCESS);
export const connectToMqttFailure = createAction(CONNECT_TO_MQTT_FAILURE);
export const DISCONNECT_FROM_MQTT_REQUEST = action("DISCONNECT_FROM_MQTT_REQUEST");
export const DISCONNECT_FROM_MQTT_SUCCESS = action("DISCONNECT_FROM_MQTT_SUCCESS");
export const DISCONNECT_FROM_MQTT_FAILURE = action("DISCONNECT_FROM_MQTT_FAILURE");
export const disconnectFromMqttRequest = createAction(DISCONNECT_FROM_MQTT_REQUEST);
export const disconnectFromMqttSuccess = createAction(DISCONNECT_FROM_MQTT_SUCCESS);
export const disconnectFromMqttFailure = createAction(DISCONNECT_FROM_MQTT_FAILURE);
export const SUBSCRIBE_TO_MQTT_TOPIC_REQUEST = action("SUBSCRIBE_TO_MQTT_TOPIC_REQUEST");
export const SUBSCRIBE_TO_MQTT_TOPIC_SUCCESS = action("SUBSCRIBE_TO_MQTT_TOPIC_SUCCESS");
export const SUBSCRIBE_TO_MQTT_TOPIC_FAILURE = action("SUBSCRIBE_TO_MQTT_TOPIC_FAILURE");
export const subscribeToMqttTopicRequest = createAction(SUBSCRIBE_TO_MQTT_TOPIC_REQUEST);
export const subscribeToMqttTopicSuccess = createAction(SUBSCRIBE_TO_MQTT_TOPIC_SUCCESS);
export const subscribeToMqttTopicFailure = createAction(SUBSCRIBE_TO_MQTT_TOPIC_FAILURE);
export const UNSUBSCRIBE_FROM_MQTT_TOPIC_REQUEST = action("UNSUBSCRIBE_FROM_MQTT_TOPIC_REQUEST");
export const UNSUBSCRIBE_FROM_MQTT_TOPIC_SUCCESS = action("UNSUBSCRIBE_FROM_MQTT_TOPIC_SUCCESS");
export const UNSUBSCRIBE_FROM_MQTT_TOPIC_FAILURE = action("UNSUBSCRIBE_FROM_MQTT_TOPIC_FAILURE");
export const unsubscribeFromMqttTopicRequest = createAction(UNSUBSCRIBE_FROM_MQTT_TOPIC_REQUEST);
export const unsubscribeFromMqttTopicSuccess = createAction(UNSUBSCRIBE_FROM_MQTT_TOPIC_SUCCESS);
export const unsubscribeFromMqttTopicFailure = createAction(UNSUBSCRIBE_FROM_MQTT_TOPIC_FAILURE);
export const setWasPreviouslyConnectedToMqtt = createAction(action("SET_WAS_PREVIOUSLY_CONNECTED_TO_MQTT"));
export const mqttEvent = createAction(action("MQTT_EVENT"));
// publish/viewStreamTaskManager listens to a kill all event
const CLEARALL_STREAM_TASKS = action("CLEARALL_STREAM_TASKS");
export const clearAllStreamTasks = createAction(CLEARALL_STREAM_TASKS);
export const killAllAction = createAction(action("APP_IS_EXITING"));
export const setBrowserAction = createAction(action("SET_BROWSER_INFO"));
export const setStatsAction = createAction(action("SET_KEEP_STATS"));
//# sourceMappingURL=actions.js.map